import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './state/store';
import initInterceptors from './utils/interceptors';

// Globally register all `_base`-prefixed components
import '@components/_globals';

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException;
}

initInterceptors();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
